// 负责所有全局自定义组件的注册
import ExportData from "@/components/MyComponents/ExportData";

export default {
    install(Vue) {
        // 组件注册
        Vue.component('ExportData', ExportData);
    },
};